import { PropsWithChildren } from 'react';
import HomeIcon from '@mui/icons-material/Home';
import CategoryIcon from '@mui/icons-material/Category';
import ExtensionIcon from '@mui/icons-material/Extension';
import LibraryBooksIcon from '@mui/icons-material/LibraryBooks';
import CreateIcon from '@mui/icons-material/AddCircleOutline';
import MenuIcon from '@mui/icons-material/Menu';
import SearchIcon from '@mui/icons-material/Search';
import NotificationsIcon from '@mui/icons-material/Notifications';
import SettingsIcon from '@mui/icons-material/Settings';
import {
  Sidebar,
  SidebarDivider,
  SidebarGroup,
  SidebarItem,
  SidebarPage,
  SidebarScrollWrapper,
  SidebarSpace,
  sidebarConfig,
  useSidebarOpenState,
} from '@backstage/core-components';
import { UserSettingsSignInAvatar } from '@backstage/plugin-user-settings';
import LogoFull from './LogoFull';
import LogoIcon from './LogoIcon';

const SidebarLogo = () => {
  const { isOpen } = useSidebarOpenState();

  return (
    <div
      style={{
        width: sidebarConfig.drawerWidthClosed,
        height: 3 * sidebarConfig.logoHeight,
        display: 'flex',
        flexFlow: 'row nowrap',
        alignItems: 'center',
        marginBottom: -14,
      }}
    >
      <a
        href="/"
        style={{ width: sidebarConfig.drawerWidthClosed, marginLeft: 24 }}
      >
        {isOpen ? <LogoFull /> : <LogoIcon />}
      </a>
    </div>
  );
};

export const Root = ({ children }: PropsWithChildren<{}>) => (
  <SidebarPage>
    <Sidebar>
      <SidebarLogo />
      <SidebarGroup label="Menu" icon={<MenuIcon />}>
        <SidebarItem icon={HomeIcon} to="/" text="Home" />
        <SidebarItem icon={CategoryIcon} to="catalog" text="Catalog" />
        <SidebarItem icon={ExtensionIcon} to="api-docs" text="APIs" />
        <SidebarItem icon={LibraryBooksIcon} to="docs" text="Docs" />
        <SidebarItem icon={CreateIcon} to="create" text="Create..." />
        <SidebarDivider />
        <SidebarItem icon={SearchIcon} to="search" text="Search" />
        <SidebarItem icon={NotificationsIcon} to="notifications" text="Notifications" />
        <SidebarScrollWrapper />
      </SidebarGroup>
      <SidebarSpace />
      <SidebarDivider />
      <SidebarGroup label="Settings" icon={<UserSettingsSignInAvatar />} to="/settings">
        <SidebarItem icon={SettingsIcon} to="settings" text="Settings" />
      </SidebarGroup>
    </Sidebar>
    {children}
  </SidebarPage>
);
